import React, { Fragment , useState } from 'react';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';

import {
  formatCandidateName,
  formatElectionType,
  formatMoney,
  formatRace,
  formatState,
  sortElectionType,
  useDebounce
} from '../../common';

const states = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
};

const ChooseRaces = ({name, choices, selected, onChange, clear}) => {

  const [officeFilter, setOfficeFilter] = useState('');
  const [stateFilter, setStateFilter] = useState('');

  const filteredChoices =  choices.filter((choice, index) => {
    const otherIndex = choices.findIndex(element => element.value === choice.value);
    return otherIndex === index;
  }).filter(choice => {
    const stateMatch  = stateFilter ? String(choice.label).toUpperCase().indexOf(stateFilter) > -1 : true;
    const officeMatch  = officeFilter ? (officeFilter === 'house' ? String(choice.label).toLowerCase().indexOf('senate') === -1 && String(choice.label).toLowerCase().indexOf('president') === -1 : String(choice.label).toLowerCase().indexOf(officeFilter) > -1) : true;
    // console.log('filterMatch', filterMatch)
    // console.log('stateMatch', stateMatch)
    return stateMatch && officeMatch;
  });

  return (
    <div style={{minWidth: 350}}>
      <div className="text-center my-1">
        <img src="/assets/primary-logo_modal-popup.svg" style={{width: 200}} />
      </div>
      <h1 className="text-center">Choose your race(s)</h1>
      <Row className="mb-3">
        <Col>
          <Form.Select
            aria-label="Filter by State"
            onChange={e => setStateFilter(e.target.value)}
          >
            <option value=''>Any State</option>
            {Object.keys(states).map(state => (
              <option
                key={`state-option-${state}`}
                value={state}
              >
                {formatState(state)}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col>
          <Form.Select
            aria-label="Filter by Office"
            onChange={e => setOfficeFilter(e.target.value)}
          >
            <option value=''>Any Office</option>
            <option value="house">House</option>
            <option value="senate">Senate</option>
            <option value="president">President</option>
          </Form.Select>
        </Col>
      </Row>
      {selected.length > 0 ? (
        <div className="my-2">
          <strong>Races Selected: </strong> {selected.map(race => formatRace(race)).join(', ')}
          (<a
            href="#"
            onClick={clear}
          >
            clear all
          </a>)
        </div>
      ) : null}
      <ListGroup style={{maxHeight: 250, overflow: 'scroll'}} variant="flush">
        {filteredChoices.map(choice => (
          <ListGroup.Item
            key={`${name}-option-${choice.value}`}
          >
            <Form.Check
               type="checkbox"
               id={`${name}-${choice.value}`}
               label={choice.label}
               checked={selected.includes(choice.value)}
               onChange={e => {
                 e.stopPropagation();
                 onChange(choice.value);
               }}
             />
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  )
};

export default ChooseRaces;
